
export const root = {
    fontSize: '0.75rem',
    fontWeight: '600',
    padding: '0.125rem 0.5rem',
    gap: '0.25rem',
    borderRadius: '10px',
    roundedBorderRadius: '{border.radius.xl}',
    borderWidth: '1px',
    borderStyle: 'solid'
};

export const icon = {
    size: '0.75rem'
};

export const colorScheme = {
    light: {
        primary: {
            background: '{primary.color}',
            color: '{primary.contrast.color}'
        },
        secondary: {
            background: '{surface.100}',
            color: '{surface.600}'
        },
        success: {
            background: '{green.50}',
            color: '{green.700}',
            borderColor: '{green.200}'
        },
        info: {
            background: '{blue.50}',
            color: '{blue.700}',
            borderColor: '{blue.200}'
        },
        warn: {
            background: '{orange.50}',
            color: '{orange.700}',
            borderColor: '{orange.200}'
        },
        danger: {
            background: '{red.50}',
            color: '{red.700}',
            borderColor: '{red.200}'
        },
        contrast: {
            background: '{surface.950}',
            color: '{surface.0}'
        }
    },
    dark: {
        primary: {
            background: '{primary.color}',
            color: '{primary.contrast.color}'
        },
        secondary: {
            background: '{surface.800}',
            color: '{surface.300}'
        },
        success: {
            background: '{green.400}',
            color: '{green.950}'
        },
        info: {
            background: '{sky.400}',
            color: '{sky.950}'
        },
        warn: {
            background: '{orange.400}',
            color: '{orange.950}'
        },
        danger: {
            background: '{red.400}',
            color: '{red.950}'
        },
        contrast: {
            background: '{surface.0}',
            color: '{surface.950}'
        }
    }
};

export default {
    root,
    icon,
    colorScheme
};
